<script setup>
import { reactive, computed, onMounted, onBeforeUnmount, watch, ref, nextTick } from 'vue'

import { useGlobalStore } from '@/stores/useGlobalStore'
import { useUserStore } from '@/stores/useUserStore'
import { useSpaceStore } from '@/stores/useSpaceStore'
import { useApiStore } from '@/stores/useApiStore'

import TagList from '@/components/TagList.vue'
import utils from '@/utils.js'
import cache from '@/cache.js'

const globalStore = useGlobalStore()
const userStore = useUserStore()
const spaceStore = useSpaceStore()
const apiStore = useApiStore()

const props = defineProps({
  visible: Boolean,
  parentIsPinned: Boolean,
  subsectionHeight: Number
})

const state = reactive({
  isLoading: false
})

const styles = computed(() => {
  return {
    maxHeight: props.subsectionHeight + 'px'
  }
})
const tags = computed(() => globalStore.getTags)
const filteredTags = computed(() => {
  let tags = globalStore.getTags
  if (shouldShowCurrentSpaceTags.value) {
    tags = spaceStore.getSpaceTags
  }
  console.info('♠︎ filteredTags', tags)
  return tags
})

const shouldShowCurrentSpaceTags = computed(() => userStore.shouldShowCurrentSpaceTags)
const toggleShouldShowCurrentSpaceTags = () => {
  const value = !shouldShowCurrentSpaceTags.value
  userStore.updateUser({ shouldShowCurrentSpaceTags: value })
}
</script>

<template lang="pug">
.tags(v-if="props.visible" :style="styles")
  section
    .row.title-row
      span Tags
      .button-wrap(@click.left.prevent="toggleShouldShowCurrentSpaceTags" @keydown.stop.enter="toggleShouldShowCurrentSpaceTags")
        label.small-button(:class="{ active: shouldShowCurrentSpaceTags }")
          input(type="checkbox" v-model="shouldShowCurrentSpaceTags")
          span In Current Space Only

    section.subsection(v-if="!tags.length")
      p Use tags to help cards stand out, and to connect ideas across spaces.
      p Type
        span {{' '}}
        span.badge.secondary [[
        span when editing a card to create tags.
  //- tags list
  section.results-section(v-if="tags.length")
    TagList(:tags="filteredTags" :isLoading="state.isLoading" :parentIsPinned="props.parentIsPinned" :positionTagsOnLeftSide="true")
</template>

<style lang="stylus">
.tags
  border-top 1px solid var(--primary-border)
  overflow auto
  section
    &:first-child
      border-top-left-radius 0
      border-top-right-radius 0

</style>
